import { render, staticRenderFns } from "./accident-info.vue?vue&type=template&id=014d6592"
import script from "./accident-info.vue?vue&type=script&lang=js"
export * from "./accident-info.vue?vue&type=script&lang=js"
import style0 from "./accident-info.vue?vue&type=style&index=0&id=014d6592&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports